import type { ObjectPropertyPath } from "@octopusdeploy/type-utils";
import React from "react";
import { AreaChart as RechartsAreaChart, Area } from "recharts";
import { ResponsiveChartContainer } from "./ResponsiveChartContainer";
import type { ChartStrokeColor } from "./chartColors";
import { useThemedChartColors } from "./chartColors";
export interface SparklineChartProps<TResource> {
    data: TResource[];
    dataKey: ObjectPropertyPath<TResource>;
    color: ChartStrokeColor;
}
export function SparklineChart<TResource>({ data, dataKey, color }: SparklineChartProps<TResource>) {
    const { strokes } = useThemedChartColors();
    return (<div style={{ height: 30, maxWidth: 100, width: "100%" }}>
            <ResponsiveChartContainer>
                {({ width, height }) => (<RechartsAreaChart data={data} height={height} width={width}>
                        <Area type="linear" dataKey={dataKey} strokeWidth={2} stroke={strokes[color]} fillOpacity={0} isAnimationActive={false}/>
                    </RechartsAreaChart>)}
            </ResponsiveChartContainer>
        </div>);
}
